import type { IAddress, IAddressPayload } from "../../../types";
import { addAndEditAddress } from "../../../services";
import { EAddressType, type EStoreIds } from "../../../constants";
import { getFormFieldRequirements } from "../../../utils";

export const getAddressPayload = (
  address: IAddress,
  storeId: EStoreIds,
): IAddressPayload => {
  const payload: IAddressPayload = {
    addressLabel:
      (address.addressLabel === EAddressType.OTHER
        ? address.otherAddressType
        : address.addressLabel) || "",
    appartment: address.appartment || "",
    building: address.building || "",
    "country.isocode": address.country?.isocode || "",
    defaultAddress: address.defaultAddress || false,
    firstName: address.firstName || "",
    landmark: address.landmark || "",
    latitude: address.latitude,
    longitude: address.longitude,
    streetName: address.streetName || "",
    phone: address.phone || "",
    town: address.town || address.emirate || "",
  };

  const { isQatarFormFieldRequired, isEmirateFormFieldRequired } =
    getFormFieldRequirements(storeId);

  if (isEmirateFormFieldRequired) {
    payload.emirate = address.emirate || "";
  }

  if (isQatarFormFieldRequired) {
    payload.makani = address.makani || "";
  }

  return payload;
};

export const saveAddressFormData = async (
  onFailure: () => void,
  onSuccess: () => void,
  payload: IAddressPayload,
  storeId: string,
  editInfo?: { id: string },
): Promise<void> => {
  try {
    await addAndEditAddress(onFailure, onSuccess, payload, storeId, editInfo);
  } catch (error) {
    // eslint-disable-next-line no-console -- logger
    console.error("Error adding or editing address", error);
    onFailure();
  }
};
